import { getGapi } from "./index";
import { createOptions } from "./createOptions";
import { FilesListResponse } from "./types/FilesListResponse";

export const getFileList = async (parent?: string) => {
  const gapi = getGapi();

  const { result: { files } } = await gapi.client.drive.files.list(createOptions(parent)) as FilesListResponse;

  return files;
};
